// External Imports
import produce from "immer";

// Internal Imports
import { types as authTypes } from "state/auth/types";
import { types } from "./types";

export const initialState = {
  currentBanner: null,
  banners: [],
};

export default function content(state = initialState, { type, payload }) {
  return produce(state, (draft) => {
    switch (type) {
      case authTypes.LOGOUT: {
        return initialState;
      }

      case types.SET_CURRENT_BANNER: {
        if (payload) {
          draft.currentBanner = payload;
        }
        break;
      }

      case types.SET_BANNERS: {
        if (Array.isArray(payload)) {
          draft.banners = payload;
        }
        break;
      }

      case types.SAVE_BANNER: {
        let index = draft.banners.findIndex((b) => b.id === payload.id);
        if (index > -1) {
          draft.banners[index] = { ...draft[index], ...payload };
        } else {
          draft.banners.push(payload);
        }
        break;
      }

      case types.DELETE_BANNER: {
        if (payload) {
          draft.banners = draft.banners.filter((b) => b.id !== payload);
        }
        break;
      }

      default: {
        return state;
      }
    }
  });
}
